export default __webpack_public_path__ + "static/media/32-Tranquility.b89504ab.jpeg";